<template>
  <div>
    <h4 class="mb-2">E-Mail to Board</h4>

    <div v-if="!email2BoardSettings.length">
      There is no E-Mail to Board setting for this board available. Please contact your administrator.
    </div>

    <table class="table table-sm" v-else>
      <colgroup>
        <col style="width: 25%" />
        <col style="width: 40%" />
      </colgroup>
      <thead>
        <tr>
          <th>Configured E-Mail Address</th>
          <th>Board Item Type for new Items</th>
          <th class="text-center">Enabled</th>
          <th>Processed E-Mails</th>
          <th>Last Check</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="setting in email2BoardSettings" :key="setting.email">
          <td style="vertical-align: middle">{{ setting.email }}</td>
          <td>
            <grouped-select
              :options="availableBoardCategories"
              v-model="setting.boardItemTypeGuid"
            ></grouped-select>
          </td>
          <td style="vertical-align: middle;text-align: center"><i class="far fa-check" v-if="setting.isEnabled"></i><i class="far fa-times" v-else></i></td>
          <td style="vertical-align: middle">{{setting.successfulImports}}</td>
          <td style="vertical-align: middle">{{setting.lastSync}}</td>
        </tr>
      </tbody>
    </table>

    <hr />

    <div class="d-flex justify-content-end">
      <button class="btn btn-save btn-sm btn-success" @click="save()">
        <i class="far fa-save"></i>
        Save changes
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { SettingsStore, SettingsModule } from '@/store/settings';
  import CheckboxWithLabel from '../Misc/CheckboxWithLabel.vue';
  import { EmailConfigDto } from '@/apiclient/apiclient_generated';
  import { SelectListItemGroup } from '@/components/Misc/SelectListItemGroup';
  import { BoardModule, BoardStore } from '@/store/board';
  import GroupedSelect from '@/components/Misc/GroupedSelect.vue';

  @Component({
    components: {
      GroupedSelect,
      'checkbox-with-label': CheckboxWithLabel,
    },
  })
  export default class Email2BoardSettings extends Vue {
    private isDirty = false;
    private settingsStore: SettingsModule = SettingsStore;
    private boardStore: BoardModule = BoardStore;
    private boardId: string;

    created() {
      this.boardId = this.$route.params.id;
    }

    get email2BoardSettings(): EmailConfigDto[] {
      return this.settingsStore.email2BoardSettings;
    }

    async mounted() {
      await this.settingsStore.loadEmail2BoardSettings(this.boardId);
      await this.settingsStore.loadShiftValidationSettings(this.boardId);
      await this.boardStore.getBoard(this.boardId);
      await this.boardStore.loadBoardCategories();
    }

    get availableBoardCategories() {
      const settings = this.settingsStore.shiftValidationSettings;

      const availableTypes = settings.types?.filter((_) => _.isAvailable) ?? [];
      const chosenTypes = this.email2BoardSettings.filter(_=>_.boardItemTypeGuid).map(_=> _.boardItemTypeGuid);
      const result: SelectListItemGroup[] = [];

      this.boardStore.groupedSelect.forEach((category) => {
        const types = category.items.filter((_) => availableTypes.some((t) => t.typeId === _.id) || chosenTypes.some((t) => t === _.id));

        if (types && types.length) {
          category.items = types;
          result.push(category);
        }
      });

      return result;
    }

    async save() {
      for (const _ of this.email2BoardSettings) {
        await this.settingsStore.updateEmail2BoardSettings(_);
      }
    }
  }
</script>
